// Distant flocks of birds.
import * as THREE from 'three';
import { PI } from '../lib/math.js';
import { rr } from '../lib/random.js';
import { scene } from '../core/scene.js';
import { M, add } from '../lib/factory.js';
import { pigeons } from '../world/promenade.js';

export let animateBirds;

export function buildBirds() {
  animateBirds = function animateBirds(time) {
    // pigeons peck at the ground in short bursts and shuffle round a little between pecks
    if (window.pigeonMesh && pigeons.length) {
      pigeons.forEach((p, i) => {
        const t = time * 1.3 + p.ph * 3,
          burst = Math.max(0, Math.sin(t * 0.5)),
          peck = Math.max(0, Math.sin(t * 9)) * burst;
        if (Math.sin(t * 0.23 + p.ph) > 0.97) p.r += 0.02;
        pigeonO.position.set(p.x, 0.36, p.z);
        pigeonO.rotation.set(peck * 0.55, p.r, 0);
        pigeonO.updateMatrix();
        window.pigeonMesh.setMatrixAt(i, pigeonO.matrix);
      });
      window.pigeonMesh.instanceMatrix.needsUpdate = true;
    }
    for (const f of flocks) {
      f.a += f.v * 0.016;
      f.grp.position.set(Math.cos(f.a) * f.r, f.y + Math.sin(time * 0.5) * 2, Math.sin(f.a) * f.r);
      f.grp.rotation.y = -f.a + PI;
      for (const b of f.birds) {
        const flap = Math.sin(time * b.f + b.ph);
        b.wings[0].rotation.z = flap * 0.6;
        b.wings[1].rotation.z = -flap * 0.6;
      }
    }
  };
  const flocks = [];
  // a swept, tapering wing (span along +x) shared by the distant flocks
  const birdWing = (() => {
    const sh = new THREE.Shape();
    sh.moveTo(0, 0.1);
    sh.quadraticCurveTo(0.5, 0.16, 1, -0.12);
    sh.lineTo(0.92, -0.18);
    sh.quadraticCurveTo(0.45, -0.05, 0, -0.12);
    sh.closePath();
    return new THREE.ShapeGeometry(sh, 6).rotateX(-PI / 2);
  })();
  const birdMat = M(0x2a2d33, { side: THREE.DoubleSide, flatShading: false });
  for (let f = 0; f < 3; f++) {
    const grp = new THREE.Group();
    scene.add(grp);
    // distant birds in a loose V: a small body and two swept wings that flap, each on its own beat
    const birds = [];
    for (let k = 0; k < 9; k++) {
      const b = new THREE.Group(),
        side = k % 2 ? 1 : -1,
        row = Math.ceil(k / 2);
      b.position.set(side * row * 1.4 + rr(-0.3, 0.3), rr(-0.4, 0.4), -row * 1.2 + rr(-0.3, 0.3));
      grp.add(b);
      add(new THREE.CapsuleGeometry(0.06, 0.35, 3, 6).rotateX(PI / 2), birdMat, 0, 0, 0, b);
      const wings = [-1, 1].map((sx) => {
        const w = new THREE.Group();
        b.add(w);
        add(birdWing, birdMat, 0, 0, 0, w).scale.x = sx;
        return w;
      });
      birds.push({ wings, ph: rr(0, 6), f: rr(5, 7) });
    }
    flocks.push({ grp, birds, a: rr(0, PI * 2), r: rr(40, 70), y: rr(40, 55), v: rr(0.05, 0.09) });
  }
  const pigeonO = new THREE.Object3D();
}
